export default __webpack_public_path__ + "2a5730eb90a8be72bc9334f1c06610db.ttf";